import type { PromoCodeDto } from '@dhl/mdp-api'
import type { PromoCode } from '~/modules/promocodes/model'

export const convertToPromoCode = (promoCode: PromoCodeDto): PromoCode => ({
  ...promoCode,
  discountOnShippingCosts: parseFloat((promoCode.discountOnShippingCosts * 100).toFixed(3)),
  /**
   * There is a difference between the API DTO and the local model (`~/modules/promocodes/model`).
   * As the local model is used heavily throughout the application, we normalize the API response to match the local model.
   * Aligning the API DTO and local model will be done separately soon™.
   */
  carriers: promoCode.carriers ?? [],
  fromCountries: promoCode.fromCountries ?? [],
  toCountries: promoCode.toCountries ?? [],
})
